import $ from 'jquery';
export default class Recaptcha {
    static init($root = $('body')) {
        const $element = $root.find('.g-recaptcha-response');
        if ($element.length) {
            this.addMissingLabels($element);
        }
        else {
            this.onRecaptchaAdded(() => {
                this.addMissingLabels($element);
            });
        }
    }
    static addMissingLabels($element) {
        $element.each((index, element) => {
            const $element = $(element);
            $element.attr('aria-hidden', 'true');
            $element.attr('aria-label', 'Do not use');
            $element.attr('aria-readonly', 'true');
        });
    }
    static onRecaptchaAdded(callback) {
        const targetNode = document.body;
        const config = { childList: true, subtree: true };
        const observer = new MutationObserver(mutationsList => {
            for (const mutation of mutationsList) {
                if ($(mutation.addedNodes).filter('.g-recaptcha-response').length > 0) {
                    callback();
                    observer.disconnect();
                    break;
                }
            }
        });
        observer.observe(targetNode, config);
    }
}
